import { render, staticRenderFns } from "./RatingSummaryList.vue?vue&type=template&id=86083b0c&scoped=true&"
import script from "./RatingSummaryList.vue?vue&type=script&lang=js&"
export * from "./RatingSummaryList.vue?vue&type=script&lang=js&"
import style0 from "./RatingSummaryList.vue?vue&type=style&index=0&id=86083b0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86083b0c",
  null
  
)

export default component.exports